import { CheckboxMultipleMarkedIcon } from './CheckboxMultipleMarkedIcon';

/**
 * author: Austin Andrews
 * id 4F160BFE-433B-49D1-B2DC-E7F71AF7070B
 * name checkbox-multiple-marked
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-multiple-marked.svg
 * tags
 * - Form 
 */
export const CheckboxesMarkedIcon = CheckboxMultipleMarkedIcon;
export default CheckboxesMarkedIcon